<template>
  <b-tabs v-model="tabIndex" class="flex-row navigation-tabs" card>
    <b-tab
      v-for="(tab, index) in tabs"
      :key="index"
      class="d-none"
      :title="tab.title"
      :active="index === 0"
      lazy
      @click="chooseChart"
    />
  </b-tabs>
</template>

<script>
const TABS = [
  {
    title: 'Electrical',
    ref: 'ElectricalComponent'
  },
  {
    title: 'Environmental',
    ref: 'EnvironmentalComponent'
  },
  {
    title: 'Power Quality',
    ref: 'PowerQualityComponent'
  },
  {
    title: 'Fault Panel',
    ref: 'VisnetHubFaultEventsPanel'
  }
];

export default {
  name: 'NavigationTab',
  data() {
    return {
      tabs: TABS,
      tabIndex: 0
    };
  },
  mounted() {
    const currentRoute = this.$route.name;

    this.tabIndex = this.tabs.findIndex(tabObject => tabObject.ref === currentRoute);
  },
  methods: {
    chooseChart() {
      if (event) this.$router.push({ name: this.tabs[this.tabIndex].ref });
    }
  }
};
</script>
